import React from "react";
import styles from "./summaryFeatureGroupComponent.module.scss";
import Check from "@icons/summaryFeatureGroupCheckIcon.svg";

export const SummaryFeatureGroupComponent = (props: Props) => {
  const { features } = props;

  return (
    <div className={styles.container}>
      {features?.length > 0 &&
        features
          .sort((a, b) => a.order - b.order)
          .map((feature, i) => (
            <div key={i} className={styles.featureContainer}>
              <Check viewBox="0 0 36 36" />
              {feature.text}
            </div>
          ))}
    </div>
  );
};

interface Props {
  features: {
    badges: any[];
    is_bold: boolean;
    is_italic: boolean;
    is_strikethrough: boolean;
    order: number;
    text: string;
  }[];
}
